<template>
  <b-spinner label="Loading..."></b-spinner>
</template>

<script>
export default {
  name: 'ThuxSpinner'
}
</script>
